<script>
const initData = () => {
  return {
    title: '',
    alias: '',
    state: 1,
    basePrice: 0,
    price: 0,
    infinity: 1,
    inventory: 1,
    times: 0,
    introtext: '',
    slogan: '',
    description: '',
    notice: '',
    introimage: '',
    image: '',
    hidden: 0,
  }
}

export default {
  components: {
    BaseInputFloatingLabel: () => import('@components/BaseInputFloatingLabel'),
    BaseUpload: () => import('@components/BaseUpload'),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
  },
  data() {
    return {
      submitData: this.defaultValue,
    }
  },
  computed: {
    canSetPrice() {
      return this.$can('api', 'setPrice')
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    handleInputSlogan(value) {
      const MAX_DIGIT_PER_LINE = 32
      const MAX_LINES = 3

      const valueLinesArray = value.split('\n')

      let filterLinesArray = valueLinesArray.map((line) => {
        function getOverflowIndex(string, maxDigit) {
          let digitCounter = 0

          for (let index = 0; index < string.length; index++) {
            if (digitCounter >= maxDigit) return index
            const isChinese = string.charCodeAt(index) > 255
            digitCounter += isChinese ? 2 : 1
          }
          return maxDigit
        }

        return line.substring(0, getOverflowIndex(line, MAX_DIGIT_PER_LINE))
      })

      if (filterLinesArray.length > MAX_LINES)
        filterLinesArray.splice(MAX_LINES)
      this.submitData.slogan = filterLinesArray.join('\n')
    },
  },
}
</script>

<template>
  <div>
    <el-form
      ref="form"
      :model="submitData"
      :validate-on-rule-change="false"
      label-position="top"
      class="el-form--floating"
      autocomplete="off"
    >
      <h4 class="form-block-title">是否開放購買與顯示</h4>
      <el-row>
        <el-col :span="12">
          <el-form-item label="開放購買" prop="state">
            <el-switch
              v-model="submitData.state"
              active-text="開放"
              inactive-text="關閉"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col v-if="submitData.state === 1" :span="12">
          <el-form-item label="在商店首頁" prop="hidden">
            <el-switch
              v-model="submitData.hidden"
              active-text="顯示"
              :active-value="0"
              inactive-text="隱藏"
              :inactive-value="1"
            ></el-switch>
          </el-form-item>
        </el-col>
      </el-row>

      <h4 class="form-block-title">基本設定</h4>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="預付方案名稱" prop="title" required>
            <BaseInputFloatingLabel v-model="submitData.title" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="簡短描述" prop="introtext">
            <BaseInputFloatingLabel v-model="submitData.introtext" />
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="優惠內容" prop="slogan">
            <BaseInputFloatingLabel
              :value="submitData.slogan"
              type="textarea"
              rows="3"
              resize="none"
              @input="handleInputSlogan"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="方案內容說明" prop="description">
            <BaseInputFloatingLabel
              v-model="submitData.description"
              type="textarea"
              :autosize="{ minRows: 2 }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="注意事項" prop="notice">
            <BaseInputFloatingLabel
              v-model="submitData.notice"
              type="textarea"
              :autosize="{ minRows: 2 }"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <h4 class="form-block-title">販售與抵扣設定</h4>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="原價" prop="basePrice" required>
            <el-tooltip
              :disabled="canSetPrice"
              effect="dark"
              content="申請金流並開通後即可編輯價格"
              placement="top"
            >
              <BaseInputFloatingLabel
                v-model.number="submitData.basePrice"
                :disabled="!canSetPrice"
                min="0"
              />
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="售價" prop="price" required>
            <BaseInputFloatingLabel
              v-model.number="submitData.price"
              :disabled="!canSetPrice"
              min="0"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="庫存數量" prop="infinity" required>
            <div :class="$style['form-item--split']">
              <el-radio-group v-model="submitData.infinity">
                <el-radio :label="1">無上限</el-radio>
                <el-radio :label="0">限量</el-radio>
              </el-radio-group>
              <el-input
                v-show="!submitData.infinity"
                v-model.number="submitData.inventory"
                min="0"
                size="small"
              ></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="可抵扣次數" prop="times" required>
            <BaseInputFloatingLabel v-model.number="submitData.times" min="0" />
          </el-form-item>
        </el-col>
      </el-row>
      <h4 class="form-block-title">圖片設定</h4>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="目錄縮圖" prop="introimage">
            <BaseUpload
              v-model="submitData.introimage"
              resource="product"
              suggest-size="640/480"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="介紹橫幅形象圖" prop="image">
            <BaseUpload
              v-model="submitData.image"
              resource="product"
              suggest-size="800/400"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<style lang="scss" module>
.form-item--split {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;

  :global {
    .el-radio-group {
      flex-shrink: 0;
      margin-right: 15px;
    }
    .el-input {
      max-width: 150px;
    }
  }
}
</style>
